export enum EUserRole {
  Staff = 'staff',
  Physician = 'physician',
}
